<app-modal-header [title]="title" (closeModal)="closeModal()"></app-modal-header>

<main-dynamic-form
  [form]="form"
  [fields]="fields"
  [loading]="loading"
  [showRequiredTitle]="false"
  loadingMessage="Operation in progress, please wait..."
  [confirmFirst]="true"
  confirmMessage="You are about to save this workflow. Do you want to continue?"
  (submit)="submitForm($event)"
>
</main-dynamic-form>
